import Image from 'next/image';

import { ExternalLink } from '@/ui/Link/ExternalLink';

import type { BlogPost } from './types';

type PostPreviewProps = Omit<BlogPost, 'id'>;

/**
 * Component for displaying a blog post preview.
 */
export const PostPreview = ({ image, summary, title, url }: PostPreviewProps) => (
  <ExternalLink
    href={url}
    className="
      bg-token-special-background-card
      rounded-lg tablet:rounded-3xl
      flex
      flex-col
      relative
      p-2
      h-full
      min-h-0
      shadow-none
      transition-all
      duration-[250ms]
      ease-[cubic-bezier(0.4,0,0,1)]
      hover:-translate-y-1
      hover:shadow-[0px_4px_16px_0px_rgba(0,0,0,0.02),0px_20px_70px_0px_rgba(0,0,0,0.04)]
      focus-within:outline-2
      focus-within:outline-token-gray-300
      focus-within:outline
      transform-gpu
      will-change-transform
    "
  >
    <div
      className="
      rounded-lg tablet:rounded-2xl
      overflow-hidden
      relative
      aspect-[4/3]
      w-[217px] tablet:w-full
      desktop:max-h-[184px]
      flex-shrink-0
    "
    >
      <Image
        alt={image.alt ?? title}
        className="object-cover w-full h-full"
        src={image.src}
        fill={true}
      />
    </div>

    <div className="flex flex-col flex-grow p-4 pt-4 pb-2">
      <h2
        className="
        text-lg
        font-medium
        leading-5
        mb-2
        overflow-hidden
        text-token-gray-1600
        line-clamp-1
        flex-shrink-0
      "
      >
        {title}
      </h2>

      <p
        className="
        text-smhttps://blog.matcha.xyz/article/bitcoin-etf-approved
        overflow-hidden
        text-token-gray-700
        line-clamp-3
        flex-grow
      "
      >
        {summary}
      </p>
    </div>
  </ExternalLink>
);
